import React, {Component} from 'react';
import InputMask from 'react-input-mask';

export default class WeexInput extends Component {

    inputNumber = () => {
        return (<input step="1" className="input" min="14" max="100" type="number" name={this.props.name} placeholder={this.props.placeholder} onChange={this.props.onChange} required={this.props.required}/>)
    }

    inputPadrao = () => {
        return (<input className="input" type={this.props.type} name={this.props.name} placeholder={this.props.placeholder} onChange={this.props.onChange} required={this.props.required}/>)
    }

    inputListaNumero = () => {
        let min = this.props.min
        let max = this.props.max
        let itens = []
        for (var i = min; i <= max; i++) {
            itens.push((<option key={"value_option_" + i} value={i} selected={this.props.value && this.props.value == i}>{i}</option>))
        }
        return (
            <select className="input" required={this.props.required} name={this.props.name} onChange={this.props.onChange}>
                {itens}
            </select>
        )
    }

    render() {

        let input = null
        switch (this.props.type) {
            case 'listaNumero':
                input = this.inputListaNumero()
            break
            case 'number':
                if (this.props.max && this.props.min) {
                    input = this.inputNumber()
                } else {
                    input = this.inputPadrao()
                }
            break
            default:
                input = this.inputPadrao()
        }

        return (
            <div className="field">
                <label className="label">{this.props.label}</label>
                <div className="control">
                    {this.props.mascara ? (
                        <div>
                            <InputMask className="input" mask={this.props.mascara} maskChar={null} name={this.props.name} onChange={this.props.onChange} required={this.props.required}/>
                            {this.props.legenda ? (
                                <div>
                                    <span className="legenda-input">{this.props.legenda}</span>
                                </div>
                            ) : (null)}
                        </div>
                    ) : (
                        input
                    )}
                </div>
            </div>
        )
    }
}